import { SortDirection, SortEvent } from '@allianz/ng-aquila/table';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { AppConfig } from 'src/config/app.config';
import { AuthService } from '../core/auth/auth.service';
import { CustomErrorHandler } from '../core/custom-error-handler';
import { PolicyStatus } from '../core/policyStatus.model';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';

@Component({
  selector: 'app-policy-report-with-price-splitup',
  templateUrl: './policy-report-with-price-splitup.component.html',
  styleUrls: ['./policy-report-with-price-splitup.component.css'],
  standalone: false
})
export class PolicyReportWithPriceSplitupComponent implements OnInit {


  @Input() policyStartDate: moment.Moment;
  @Input() policyEndDate: moment.Moment;
  @Input() policyNo: string;
  @Input() policyType: Array<number>;
  @Input() policyStatus: typeof PolicyStatus;
  @Input() VehicleAge: number;
  @Input() model: string;
  reportSearchForm: FormGroup;

  fileName: string;
  ReportData: any;
  exportdata: any = [];
  _apiUrl: string;
  clientId: number;
  userTypeId: number;
  userBaseTypeId: number;
  userId: number;

  /** sorting starts here */

  sortTable(sort: SortEvent) {
    this.ReportData = this.ReportData.sort((a, b) => {
      if (sort.active in a && sort.active in b) {
        return this.compare(a[sort.active], b[sort.active], sort.direction);
      }
      return 0;
    });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    direction: SortDirection
  ) {
    return (a < b ? -1 : 1) * (direction === "asc" ? 1 : -1);
  }
  /** sorting ends here */
  /**Pagination Start */
  count: number = 0;
  pageNumber: number = 1;
  pageSize: number = 10;
  searchTerm: any = "";
  prevPage() {
    this.pageNumber--;
    this.getReportData();
  }

  nextPage() {
    this.pageNumber++;
    this.getReportData();
  }

  goToPage(n: number) {
    this.pageNumber = n;
    this.getReportData();
  }
  /**Pagination end */

  constructor(
    private authService: AuthService,
    private appConfig: AppConfig,
    private errorHandler: CustomErrorHandler
  ) {
    this._apiUrl = appConfig.baseUrl;
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this.userBaseTypeId = parseInt(atob(localStorage.getItem("USER_BASE_TYPE_ID")));
    this.userTypeId = parseInt(atob(localStorage.getItem("USER_TYPE_ID")));

  }
  ngOnInit(): void {
    this.searchReportFormBuilder();
  }

  searchReportFormBuilder() {
    this.reportSearchForm = new FormGroup({
      startDatepicker: new FormControl(null),
      endDatepicker: new FormControl(null),
      policyNo: new FormControl(null),
      policyType: new FormControl(new Array<number>()),
      VehicleAge: new FormControl(-1),
      model: new FormControl(null),
      ClientId: new FormControl(this.clientId),
      WorkshopId: new FormControl(null),
    });
  }

  loadReport() {
    this.pageNumber = 1;
    this.getReportData();
  }

  getReportData() {
    this.searchReportFormBuilder();
    this.updateReportSearchForm();

    this.authService.PostList(this._apiUrl + `/api/v1/Report/GetPolicyReportWithPriceSplitUp?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}`, this.reportSearchForm.value)
      .subscribe(response => {
        if (response) {

          this.ReportData = response.body;
          var pagingProp = JSON.parse(response.headers.get('X-Pagination'));
          this.count = pagingProp.TotalCount;
        }
      }, (error) => {
        this.errorHandler.handleError(error);
      });
  }

  updateReportSearchForm() {
    if (this.policyStartDate) this.reportSearchForm.patchValue({ "startDatepicker": this.policyStartDate.format('LL') });
    if (this.policyStartDate) this.reportSearchForm.patchValue({ "startDatepicker": this.policyStartDate.format('LL') });
    if (this.policyEndDate) this.reportSearchForm.patchValue({ "endDatepicker": this.policyEndDate.format('LL') });
    if (this.policyNo) this.reportSearchForm.patchValue({ "policyNo": this.policyNo });
    if (this.policyType) this.reportSearchForm.patchValue({ "policyType": this.policyType });
    if (this.VehicleAge) this.reportSearchForm.patchValue({ "VehicleAge": this.VehicleAge });
    if (this.model) this.reportSearchForm.patchValue({ "model": this.model });
  }

  exporttoexcel() {
    this.pageNumber = -1;
    this.getExportData();
  }

  getExportData() {
    this.searchReportFormBuilder();
    this.updateReportSearchForm();

    this.authService.PostList(this._apiUrl + `/api/v1/Report/GetPolicyReportWithPriceSplitUp?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}`, this.reportSearchForm.value)
      .subscribe(
        (response) => {
          if (response) {
            this.exportdata = [];
            response.body.forEach((element) => this.setExportData(element));
            this.bindexcel();
          }
        },
        (error) => {

        }
      );
  }

  setExportData(item: any) {
    const data: any = {};
    data.dealerCode = item.dealerCode;
    data.dealerName = item.name;
    data.dealerManager = item.asmName;
    data.invoiceNo = item.policyDetails.invoiceNo;
    data.vin = item.policyDetails.vinChassisNo;
    data.licencePlateNo = item.policyDetails.licensePlateNo;

    data.model = item.policyDetails.model;
    data.policyName = item.policyDetails.policyName;
    data.effectiveDate = new Date(item.policyDetails.effectiveDate).toLocaleDateString();
    data.expiryDate = new Date(item.policyDetails.expiryDate).toLocaleDateString();

    data.awpRiskPrice = item.planDetails.awpRiskPrice;
    data.royality = item.planDetails.royality;
    data.dealerMargin = item.planDetails.dealerMargin;
    data.customerEngementFund = item.planDetails.customerEngementFund;
    data.marketingFund = item.planDetails.marketingFund;
    data.cessAmount = item.policyDetails.cessAmount;
    data.gstPrice = item.policyDetails.gstPrice;
    data.price = item.policyDetails.unitPrice;

    data.zone = item.zonename;
    data.custName = item.policyDetails.customerFirstName + ' ' + item.policyDetails.customerLastName;
    data.custMobile = item.policyDetails.customerMobileNo;
    data.custEmail = item.policyDetails.customerEmail;
    data.invoiceDate = new Date(item.policyDetails.invoiceDate).toLocaleDateString();

    if (item.policyDetails.policyStatusId == PolicyStatus.Active) {
      data.policyStatus = "Active";
    } else if (item.policyDetails.policyStatusId == PolicyStatus.Cancel) {
      data.policyStatus = "Cancel";
    } else if (item.policyDetails.policyStatusId == PolicyStatus.Modified) {
      data.policyStatus = "Modified";
    } else if (item.policyDetails.policyStatusId == PolicyStatus.CancelationApprovalPending) {
      data.policyStatus = "Cancelation Approval Pending";
    } else if (item.policyStatusId == PolicyStatus.ModificationApprovalPending) {
      data.policyStatus = "Modification Approval Pending";
    }
    this.exportdata.push(data);
  }

  bindexcel() {
    /* json data is passed over here */
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Policy_Detailed_Sale_Report');

    worksheet.columns = [
      { header: 'Dealer/Workshop Code', key: 'dealerCode', width: 20 },
      { header: 'Dealer/Workshop Name', key: 'dealerName', width: 30 },
      { header: 'Dealer Manager', key: 'dealerManager', width: 25 },
      { header: 'Invoice No', key: 'invoiceNo', width: 20 },
      { header: 'Vin Chasis No', key: 'vin', width: 25 },
      { header: 'License Plate No', key: 'licencePlateNo', width: 20 },
      { header: 'Model', key: 'model', width: 20 },
      { header: 'Policy Name', key: 'policyName', width: 25 },
      { header: 'Effective Date', key: 'effectiveDate', width: 15 },
      { header: 'Expiry Date', key: 'expiryDate', width: 15 },
      { header: 'AWP Risk Price', key: 'awpRiskPrice', width: 15 },
      { header: 'Royality', key: 'royality', width: 15 },
      { header: 'Dealer Margin', key: 'dealerMargin', width: 15 },
      { header: 'Customer Engagement Fund', key: 'customerEngementFund', width: 20 },
      { header: 'Marketing Fund', key: 'marketingFund', width: 15 },
      { header: 'Cess Amount', key: 'cessAmount', width: 15 },
      { header: 'GST Price', key: 'gstPrice', width: 15 },
      { header: 'Unit Price', key: 'price', width: 15 },
      { header: 'Zone', key: 'zone', width: 15 },
      { header: 'Customer Name', key: 'custName', width: 30 },
      { header: 'Customer Mobile', key: 'custMobile', width: 20 },
      { header: 'Customer Email', key: 'custEmail', width: 30 },
      { header: 'Invoice Date', key: 'invoiceDate', width: 15 },
      { header: 'Policy Status', key: 'policyStatus', width: 25 },
    ];

    // Add all rows
    this.exportdata.forEach((item: any) => {
      worksheet.addRow(item);
    });
    /* save to file */
    this.fileName =
      "PolicyDetailedSaleReport_" +
      new Date(Date.now()).toLocaleString().split(",")[0] +
      ".xlsx";
    this.saveAsExcelFile(workbook, this.fileName);
  }

  saveAsExcelFile(wb: any, fileName: string): void {
    wb.xlsx.writeBuffer().then((data) => {
      var blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var a = window.document.createElement('a');
      var downloadUrl = window.URL.createObjectURL(blob);
      a.href = downloadUrl;
      a.download = `${fileName}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
    });
  }
}
